import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },
  updateCitiPcanModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight:"600",
      lineHeight:"28px",
      overflowWrap: "break-word"
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "8px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  btnContainer:{
    marginTop:"32px",
    marginBottom:"12px",
  },

  inputContainer:{
    marginBottom: "20px",
    marginTop: "16px"
  },

  cancelBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
    height: "100%",
    alignItems: "center"
  },
  createBtn: {
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px"
  },
  colRemove:{
    padding:"0px",
    marginLeft:"6px"
  },
  label:{
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color: colors.grey,
    marginBottom:"6px"
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  dividerContainer:{
    display: "flex",
    alignItems: "center",
  },
  border:{
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px"
  },
  deleteBtn:{
    justifyContent:"left",
    padding:"0px",
    minWidth:"160px",
    border:"none",
    fontSize: "16px",
    color:colors.darkRed,
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
    "& svg":{
      marginRight:"10px"
    },
    "&:hover": {
      outline: "none",
      border:"none",
      color:colors.darkRed,
    },
    "&:focus": {
      outline: "none",
      border:"none",
      color:colors.darkRed,
    }
  },
  deleteContainer:{
    marginBottom:"16px"
  },
  deleteText: {
    display: "flex",
    textAlign: "center",
    alignItems: "center"
  },
  nameError: {
    fontSize: "14px",
    fontWeight:"400",
    color: colors.red,
    marginTop: "6px"
  },
}));

export default styles;